/* Vendly MSA signing page (2026-09-21). Externalized so the custom-liquid section validates.
   ENDPOINT: deployed signed-copy endpoint that emails the CLIENT their own copy + logs a hardened
   server timestamp. Left empty until deployed -> beacon skipped, native Shopify contact form still
   emails jacob@vendly.ink and is server-timestamped. */
(function () {
  var ENDPOINT = "https://msa-sign-endpoint.vercel.app/api/sign";
  var SECRET = "2e7cf63d51d24c9d877b6676ed76abd8";
  try {
    if (location.search.indexOf('contact_posted=true') > -1) {
      var th = document.getElementById('msa-thanks');
      var fm = document.getElementById('msa-form');
      if (th) { th.hidden = false; th.scrollIntoView({ block: 'center' }); th.focus({ preventScroll: true }); }
      if (fm) { fm.style.display = 'none'; }
    }
    var d = document.getElementById('msa-date');
    if (d) {
      var t = new Date();
      var mm = String(t.getMonth() + 1).padStart(2, '0');
      var dd = String(t.getDate()).padStart(2, '0');
      d.value = mm + '/' + dd + '/' + t.getFullYear();
    }
    var f = document.getElementById('msa-form');
    if (f) {
      f.addEventListener('submit', function () {
        try {
          var val = function (id) { var e = document.getElementById(id); return e ? (e.value || '') : ''; };
          var biz = val('msa-business'), signer = val('msa-signer'), email = val('msa-email');
          /* the agreement name is read from the page's own hidden field so the emailed copy can never name a different version than the text the signer read (was hardcoded v4 while the page shipped v5, 2026-09-21) */
          var agEl = document.querySelector('input[name="contact[Agreement]"]'); var agreement = (agEl && agEl.value) ? agEl.value : 'Vendly Client Agreement';
          var plan = val('msa-plan'), sig = val('msa-sig'), dt = val('msa-date');
          var nowIso = new Date().toISOString();
          var tz = '';
          try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
          var ua = (navigator.userAgent || '').slice(0, 180);
          var u = document.getElementById('msa-signed-utc'); if (u) { u.value = nowIso; }
          var z = document.getElementById('msa-tz'); if (z) { z.value = tz; }
          var g = document.getElementById('msa-ua'); if (g) { g.value = ua; }
          var s = document.getElementById('msa-body-summary');
          if (s) {
            s.value = agreement + ' signed online. Business: ' + biz + '. Signer: ' + signer +
              '. Plan: ' + plan + '. Typed signature: ' + sig + '. Date: ' + dt +
              '. Signed at (UTC): ' + nowIso + '. Timezone: ' + tz + '.';
          }
          if (ENDPOINT && ENDPOINT.indexOf('http') === 0) {
            var payload = JSON.stringify({
              secret: SECRET, agreement: agreement,
              business: biz, signer: signer, email: email, plan: plan,
              typed_signature: sig, date_shown: dt, signed_at_utc: nowIso,
              timezone: tz, user_agent: ua, page: location.href
            });
            try { fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true }); } catch (e) {}
          }
        } catch (e) {}
        /* native Shopify contact form submits normally -> Jacob's copy + a server timestamp */
      });
    }
  } catch (e) {}
})();
